import { render, staticRenderFns } from "./QuestionResultArea.vue?vue&type=template&id=4bb2585a&scoped=true&lang=pug&"
import script from "./QuestionResultArea.vue?vue&type=script&lang=ts&"
export * from "./QuestionResultArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2585a",
  null
  
)

export default component.exports